import { countryList } from "./countryList"

/**
 * Allow SSO content to be displayed
 * @returns {Boolean}
 */
export function isSSOAvailable() {
    countryList["de"] = true
    countryList["tmpde"] = true

    const lang = window.location.pathname.split("/")[1]

    return countryList[lang] ?? false
}
